/* eslint-disable @reatom/unit-naming-rule */
import { action } from '@reatom/framework'

import { type FavoritePairsChangedEvent } from '../model/favorite-pair-change-event'

export const favoritePairsChangedEvent = action<FavoritePairsChangedEvent>(
  'favoritePairsChangedEvent',
)
